import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { selectTours } from "../../../app/features/cartSlice";
import { recomendedTours } from "../../../utils/data";
import Resumen from "./resumen";
import { Link, useParams } from "react-router-dom"
import Recomendations from "./recomendations";
import { useScreenDetector } from "../../../hooks/useScreenDetector";
import { useNavigate } from "react-router-dom";
import useFetchSuggestTours from "../../../hooks/API/Tours/useFetchSuggestTours";
import MediaCard from "../../../components/ProductCard3"

const Step1 = () => {
    const { t } = useTranslation(['paths', 'checkout', 'components']);
    const { isMobile } = useScreenDetector()
    const cartTours = useSelector(selectTours);
    const navigate = useNavigate();
    const tours = useSelector(state => state.cart.checkout.tours);
    const [fetchParams, setFetchParams] = useState(null);
    const [recommendations, setRecommendations] = useState(null);
    const suggestedTours = useFetchSuggestTours(fetchParams);
    const [city, setCity] = useState(null);
    const handleScrollToTop = () => {
        window.scrollTo(0, 0); // Mueve la pantalla al inicio (x = 0, y = 0)
    };

    const handleNext = () => {
        navigate(`/checkout/${t('paths:checkout-step2')}`)
    }

    useEffect(() => {
        // Desplaza hacia el inicio al cargar la página
        window.scrollTo(0, 0);
    }, []);


    const getRandomProperty = (array, property) => {
        if (!array.length) return null; // Manejo de arreglos vacíos
        const randomIndex = Math.floor(Math.random() * array.length); // Índice aleatorio
        return array[randomIndex][property]; // Devuelve la propiedad
    };

    useEffect(() => {
        if (tours.length) {
            const city = getRandomProperty(tours, 'city');
            setFetchParams({ city, limit: 3 });
        }
    }, [tours]);


    useEffect(() => {
        if (suggestedTours?.tourList) {
            const toursRecommended = suggestedTours.tourList.map((tour) => ({
                title: tour.name,
                shortDescription: tour.shortDescription,
                price: tour.price,
                imageUrl: tour.cover,
                rate: tour.scores?.score,
                reviews: tour.reviewsTotal,
                city: { slug: tour.city.slug },
                slug: tour.slug,
                freeCancelation: tour.freeCancelation,
                duration: tour.duration,
                languages: tour.languages
            }));
            setRecommendations(toursRecommended);
        }
    }, [suggestedTours]);

    return (
        <>
            <Helmet>
                <title>{t('checkout:step1-page')}</title>
            </Helmet>
            <Resumen handleNext={handleNext} />
            {/* {(!isMobile && recommendations) && <Recomendations city={city} recomendedTours={recommendations} />} */}
            {recommendations && recommendations.map((tour, index) => (
                <Link style={{
                    textDecoration: 'none',
                    display: "flex",
                    justifyContent: "center",

                }} key={index} onClick={handleScrollToTop} to={`/tour/${tour.city.slug}/${tour.slug}`}>
                    <MediaCard
                        key={`${tour.title}${index}`}
                        {...tour}
                    />
                </Link>
            ))}
        </>
    )
}

export default Step1;


/*
{
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        languages: null,
        time: null,
        cancelable: false,
        rate: 8.2,
        price: 150.5,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        description: `Lorem ipsum dolor sit amet consectetur. Aliquet amet in proin nibh. 
            Habitasse metus quis at est platea sem venenatis pellentesque. Commodo velit nisl
            diam magnis massa volutpa.`,
        title: 'Sendero Kalalau y gastronomía local',
        date: '10 de junio de 2024',
        type: 'Paquete premium(150€)',
        assistants: '1 adulto, 3 ninos',
        moreDetails: false,
        edit: true,
        remove: true
    }
*/